import { DictionaryBase } from './types';
const SysUserStatus = new DictionaryBase('用户状态', [
    {
        id: 0,
        name: '正常状态',
        symbol: 'NORMAL',
    },
    {
        id: 1,
        name: '锁定状态',
        symbol: 'LOCKED',
    },
]);
const SysDeptType = new DictionaryBase('机构类型', [
    {
        id: '平台',
        name: '平台公司',
        symbol: 'PLATFORM',
    },
    {
        id: '代理',
        name: '代理公司',
        symbol: 'AGENCY',
    },
    {
        id: '进仓',
        name: '进仓公司',
        symbol: 'DEPARTMENT',
    },
]);
const AppType = new DictionaryBase('平台类型', [
    {
        id: 'web',
        name: 'Web平台',
        symbol: 'WEB',
    },
    {
        id: 'wechat',
        name: '小程序',
        symbol: 'WECHAT',
    },
    {
        id: 'pda',
        name: 'PDA',
        symbol: 'PDA',
    },
]);
const SysUserType = new DictionaryBase('用户类型', [
    {
        id: 0,
        name: '管理员',
        symbol: 'ADMIN',
    },
    {
        id: 1,
        name: '系统操作员',
        symbol: 'SYSTEM',
    },
    {
        id: 2,
        name: '普通操作员',
        symbol: 'OPERATOR',
    },
]);
const SysOperationType = new DictionaryBase('操作日志操作类型', [
    {
        id: 0,
        name: '登录',
        symbol: 'LOGIN',
    },
    {
        id: 1,
        name: '手机登录',
        symbol: 'MOBILE_LOGIN',
    },
    {
        id: 5,
        name: '登出',
        symbol: 'LOGOUT',
    },
    {
        id: 10,
        name: '新增',
        symbol: 'ADD',
    },
    {
        id: 15,
        name: '修改',
        symbol: 'UPDATE',
    },
    {
        id: 20,
        name: '删除',
        symbol: 'DELETE',
    },
    {
        id: 35,
        name: '查询',
        symbol: 'LIST',
    },
    {
        id: 40,
        name: '分组查询',
        symbol: 'LIST_WITH_GROUP',
    },
    {
        id: 45,
        name: '导出',
        symbol: 'EXPORT',
    },
    {
        id: 50,
        name: '上传',
        symbol: 'UPLOAD',
    },
    {
        id: 55,
        name: '下载',
        symbol: 'DOWNLOAD',
    },
    {
        id: 60,
        name: '重置缓存',
        symbol: 'RELOAD_CACHE',
    },
]);
const SysPermModuleType = new DictionaryBase('权限分组类型', [
    {
        id: 0,
        name: '分组模块',
        symbol: 'GROUP',
    },
    {
        id: 1,
        name: '接口模块',
        symbol: 'CONTROLLER',
    },
]);
/**
 * 菜单类型
 *
 * DIRECTORY(0: 目录)
 * MENU(1: 表单)
 * FRAGMENT(2: 片段)
 * BUTTON(3: 按钮)
 */
const SysMenuType = new DictionaryBase('菜单类型', [
    {
        id: 0,
        name: '目录',
        symbol: 'DIRECTORY',
    },
    {
        id: 1,
        name: '菜单',
        symbol: 'MENU',
    },
    {
        id: 2,
        name: '片段',
        symbol: 'FRAGMENT',
    },
    {
        id: 3,
        name: '按钮',
        symbol: 'BUTTON',
    },
]);
const MobileEntryType = new DictionaryBase('移动端首页配置项类型', [
    {
        id: 0,
        name: '轮播图',
        symbol: 'BANNER',
    },
    {
        id: 1,
        name: '九宫格',
        symbol: 'SUDOKU',
    },
    {
        id: 2,
        name: '分组',
        symbol: 'GROUP',
    },
]);
/**
 * 菜单绑定类型
 *
 * ROUTER(0: 路由菜单)
 * THRID_URL(4: 外部链接)
 */
const SysMenuBindType = new DictionaryBase('菜单绑定类型', [
    {
        id: 0,
        name: '路由菜单',
        symbol: 'ROUTER',
    },
    {
        id: 4,
        name: '外部链接',
        symbol: 'THRID_URL',
    },
]);
const SysDataPermType = new DictionaryBase('数据权限类型', [
    {
        id: 0,
        name: '查看全部',
        symbol: 'ALL',
    },
    {
        id: 1,
        name: '仅看自己',
        symbol: 'ONLY_USER',
    },
    {
        id: 2,
        name: '仅看所在机构',
        symbol: 'ONLY_DEPT',
    },
    {
        id: 3,
        name: '仅看所在机构及子机构',
        symbol: 'ONLY_DEPT_AND_CHILD',
    },
    {
        id: 4,
        name: '自选机构及子机构',
        symbol: 'CUSTOM_DEPT_AND_CHILD',
    },
    {
        id: 5,
        name: '仅自选机构',
        symbol: 'CUSTOM_DEPT',
    },
    {
        id: 6,
        name: '本机构用户',
        symbol: 'DEPT_USER',
    },
    {
        id: 7,
        name: '本机构及子机构用户',
        symbol: 'DEPT_AND_CHILD_USER',
    },
]);
const SysPermCodeType = new DictionaryBase('权限字类型', [
    {
        id: 0,
        name: '表单',
        symbol: 'FORM',
    },
    {
        id: 1,
        name: '片段',
        symbol: 'FRAGMENT',
    },
    {
        id: 2,
        name: '操作',
        symbol: 'OPERATION',
    },
]);
/**
 * 计费模式
 */
const CrmBillingCycleStatus = new DictionaryBase('计费模式', [
    {
        id: '日租',
        name: '日租',
        symbol: 'DAILY_RENT',
    },
]);
/**
 * 资产类型
 */
const AmAssetType = new DictionaryBase('资产类型', [
    {
        id: 1,
        name: 'RFID托盘',
        symbol: 'RFID_PALLRT',
    },
    {
        id: 2,
        name: 'IOT托盘',
        symbol: 'IOT_PALLRT',
    },
    {
        id: 3,
        name: 'RFID+IOT托盘',
        symbol: 'RFID+IOT_PALLRT',
    },
    {
        id: 4,
        name: '手持RFID设备识别',
        symbol: 'HANDHELD_RFID_DEVICE_RECOGNITION',
    },
    {
        id: 5,
        name: '通道门',
        symbol: 'ACCESS_GATE',
    },
    {
        id: 6,
        name: '无人叉车',
        symbol: 'UNMANNED_FORKLIFT',
    },
    {
        id: 7,
        name: '无人驾驶货车',
        symbol: 'DRIVERLESS_TRUCK',
    },
]);
/**
 * 设备类型
 */
const AmDeviceType = new DictionaryBase('设备类型', [
    {
        id: 1,
        name: '固定设备',
        symbol: 'FIXED_EQUIPMENT',
    },
    {
        id: 2,
        name: '移动设备',
        symbol: 'MOBILE_DEVICE',
    },
]);
/**
 * 设备进出类型
 */
const AmDeviceInOutType = new DictionaryBase('设备进出类型', [
    {
        id: 'IN',
        name: '进',
        symbol: 'IN',
    },
    {
        id: 'OUT',
        name: '出',
        symbol: 'OUT',
    },
    {
        id: 'IN/OUT',
        name: '进/出',
        symbol: 'IN/OUT',
    },
]);
/**
 * 进仓资产状态
 */
const AmInboundBatchState = new DictionaryBase('进仓资产状态', [
    {
        id: 0,
        name: '待入仓',
        symbol: 'PENDING_WAREHOUSING',
    },
    {
        id: 1,
        name: '入仓完成',
        symbol: 'WAREHOUSING_COMPLETED',
    },
]);
/**
 * 提用资产提用状态
 */
const AmUtilizedAssetsScheduledState = new DictionaryBase('提用资产提用状态', [
    {
        id: 1,
        name: '待排单',
        symbol: 'TO_BE_USED',
    },
    {
        id: 2,
        name: '已排单',
        symbol: 'ORDER_SCHEDULED',
    },
    {
        id: 3,
        name: '已出仓',
        symbol: 'DEPLOYED',
    },
]);
/**
 * 入仓明细状态
 */
const AmInboundDetailsState = new DictionaryBase('入仓明细状态', [
    {
        id: 0,
        name: '无效',
        symbol: 'INVALID',
    },
    {
        id: 1,
        name: '有效',
        symbol: 'EFFECTIVE',
    },
]);
/**
 * 货站备案状态
 */
const AmFilingStatus = new DictionaryBase('货站备案状态', [
    {
        id: 1,
        name: '未备案',
        symbol: 'UNREGISTERED',
    },
    {
        id: 2,
        name: '已备案',
        symbol: 'REGISTERED',
    },
    {
        id: 3,
        name: '备案退回',
        symbol: 'REGISTRATION_RETURNED',
    },
]);
/**
 * 资产明细管理状态
 */
const AssetDetailManagementStatus = new DictionaryBase('资产明细管理状态', [
    {
        id: 0,
        name: '无效',
        symbol: 'INVALID',
    },
    {
        id: 1,
        name: '正常',
        symbol: 'NORMAL',
    },
    {
        id: 2,
        name: '异常',
        symbol: 'ABNORMAL',
    },
    {
        id: 3,
        name: '维修',
        symbol: 'MAINTENANCE',
    },
    {
        id: 4,
        name: '报废',
        symbol: 'SCRAP',
    },
]);
/**
 * 所有数据状态
 */
const DataStatus = new DictionaryBase('所有数据状态', [
    {
        id: 1,
        name: '有效',
        symbol: 'EFFECTIVE',
    },
    {
        id: -1,
        name: '无效',
        symbol: 'INVALID',
    },
]);
/**
 * 进仓计划类型状态
 */
const PlanTypeStatus = new DictionaryBase('进仓计划类型状态', [
    {
        id: 1,
        name: '购置计划',
        symbol: 'PURCHASE',
    },
    {
        id: 2,
        name: '租赁计划',
        symbol: 'RENTAL',
    },
    {
        id: 3,
        name: '提用计划',
        symbol: 'USE',
    },
]);
/**
 * 发票类型
 */
const CrInvoiceType = new DictionaryBase('发票类型', [
    {
        id: '1',
        name: '增值税专用发票',
        symbol: 'SPECIAL_VAT_INVOICE',
    },
    {
        id: '2',
        name: '增值税普通发票',
        symbol: 'GENERAL_VAT_INVOICE',
    },
    {
        id: '3',
        name: '电子普通发票',
        symbol: 'ELECTRONIC_GENERAL_INVOICE',
    },
    {
        id: '4',
        name: '电子专用发票',
        symbol: 'ELECTRONIC_SPECIAL_INVOICE',
    },
    {
        id: '99',
        name: '其他',
        symbol: 'OTHER',
    },
]);
/**
 * 提单状态0-暂存 1-已发送
 */
const BillState = new DictionaryBase('提单状态', [
    {
        id: 0,
        name: '暂存',
        symbol: 'DRAFT',
    },
    {
        id: 1,
        name: '已发送',
        symbol: 'SENT',
    },
]);
/**
 * 提单变更状态 0-未变更 1-已变更 2-变更已重发
 */
const BillModifyState = new DictionaryBase('提单变更状态', [
    {
        id: 0,
        name: '未变更',
        symbol: 'NOT_MODIFIED',
    },
    {
        id: 1,
        name: '已变更',
        symbol: 'MODIFIED',
    },
    {
        id: 2,
        name: '变更已重发',
        symbol: 'MODIFIED_RESENT',
    },
]);
/**
 *  批次类型：01-购置进仓、02-租赁进仓、03-识别进仓  04-直接进仓 05-归还进仓 06-调仓识别进仓 07-调仓直接进仓 08-代发直接进仓  11-识别排单
 * 、13-提用出仓、14-提用预进仓 15-归还出仓  16-调仓识别排单 17-调仓提用出仓  18-代发直接出仓 19-代发预进仓
 */
const BatchType = new DictionaryBase('批次类型', [
    {
        id: '01',
        name: '购置进仓',
        symbol: 'PURCHASE',
    },
    {
        id: '02',
        name: '租赁进仓',
        symbol: 'RENTAL',
    },
    {
        id: '03',
        name: '识别进仓',
        symbol: 'IDENTIFICATION',
    },
    {
        id: '04',
        name: '直接进仓',
        symbol: 'DIRECT',
    },
    {
        id: '05',
        name: '归还进仓',
        symbol: 'RETURN',
    },
    {
        id: '06',
        name: '调仓识别进仓',
        symbol: 'TRANSFER_IDENTIFICATION',
    },
    {
        id: '07',
        name: '调仓直接进仓',
        symbol: 'TRANSFER_DIRECT',
    },
    {
        id: '08',
        name: '代发直接进仓',
        symbol: 'AGENT_DIRECT',
    },
    {
        id: '11',
        name: '识别排单',
        symbol: 'IDENTIFICATION_SCHEDULED',
    },
    {
        id: '13',
        name: '提用出仓',
        symbol: 'USE_OUTBOUND',
    },
    {
        id: '14',
        name: '提用预进仓',
        symbol: 'USE_PRE_INBOUND',
    },
    {
        id: '15',
        name: '归还出仓',
        symbol: 'RETURN_OUTBOUND',
    },
    {
        id: '16',
        name: '调仓识别排单',
        symbol: 'TRANSFER_IDENTIFICATION_SCHEDULED',
    },
    {
        id: '17',
        name: '调仓提用出仓',
        symbol: 'TRANSFER_USE_OUTBOUND',
    },
    {
        id: '18',
        name: '代发直接出仓',
        symbol: 'AGENT_DIRECT_OUTBOUND',
    },
    {
        id: '19',
        name: '代发预进仓',
        symbol: 'AGENT_PRE_INBOUND',
    },
]);
/**
 * 应收账单数据来源类型0-新增 1-合同变更 2-月度服务订阅
 */
const FinDataSourceType = new DictionaryBase('应收账单数据来源类型', [
    {
        id: 0,
        name: '新增',
        symbol: 'ADD',
    },
    {
        id: 1,
        name: '合同变更',
        symbol: 'CHANGE',
    },
    {
        id: 2,
        name: '月度服务订阅',
        symbol: 'SUBSCRIPTION',
    },
]);
/**
 * 账单状态：10-暂存 20-已发客户 30-客户确认 40-变更申请 50-变更确认 60-已作废
 */
const HandoverStatus = new DictionaryBase('账单状态', [
    {
        id: '10',
        name: '暂存',
        symbol: 'DRAFT',
    },
    {
        id: '20',
        name: '已发客户',
        symbol: 'SENT',
    },
    {
        id: '30',
        name: '客户确认',
        symbol: 'CONFIRMED',
    },
    {
        id: '40',
        name: '变更申请',
        symbol: 'CHANGE_APPLY',
    },
    {
        id: '50',
        name: '变更确认',
        symbol: 'CHANGE_CONFIRMED',
    },
    {
        id: '60',
        name: '已作废',
        symbol: 'CANCELLED',
    },
]);
/**
 * 核销状态：0-未核销 1-部分核销 2-已核销
 */
const VerifyStatus = new DictionaryBase('核销状态', [
    {
        id: '0',
        name: '未核销',
        symbol: 'UNVERIFIED',
    },
    {
        id: '1',
        name: '部分核销',
        symbol: 'PARTIAL',
    },
    {
        id: '2',
        name: '已核销',
        symbol: 'VERIFIED',
    },
]);
/**
 * 合约变更账单状态 0-待生成 1-已生成 2-已确认 3-已作废
 */
const FinStatus = new DictionaryBase('应收账单状态', [
    {
        id: 0,
        name: '待生成',
        symbol: 'PENDING_GENERATION',
    },
    {
        id: 1,
        name: '已生成',
        symbol: 'GENERATED',
    },
    {
        id: 2,
        name: '已确认',
        symbol: 'CONFIRMED',
    },
    {
        id: 3,
        name: '已作废',
        symbol: 'CANCELLED',
    },
]);
export { SysUserStatus, SysUserType, SysDataPermType, SysOperationType, SysPermModuleType, SysMenuBindType, MobileEntryType, SysMenuType, SysDeptType, SysPermCodeType, AppType, CrmBillingCycleStatus, AmAssetType, AmDeviceType, AmDeviceInOutType, AmInboundBatchState, AmUtilizedAssetsScheduledState, AmInboundDetailsState, AssetDetailManagementStatus, DataStatus, PlanTypeStatus, AmFilingStatus, CrInvoiceType, BillState, BillModifyState, BatchType, FinStatus, HandoverStatus, VerifyStatus, FinDataSourceType };
